import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MetaTagsList } from '@corefront/seo-tools';

export const buildCanonicalLink = () => {
  return `${window.location.origin}${window.location.pathname}`.replace(
    /\/$/,
    ''
  );
};

export const buildDataForSeoMetaTag = (link) => [
  {
    tagName: 'link',
    tagContent: null,
    tagAttributes: [
      {
        name: 'rel',
        value: 'canonical',
      },
      {
        name: 'href',
        value: link,
      },
      {
        name: 'key',
        value: link,
      },
    ],
  },
];

const CanonicalLink = () => {
  const [link, setLink] = useState(buildCanonicalLink());
  const location = useLocation();

  useEffect(() => {
    setLink(buildCanonicalLink());
  }, [location]);

  return <MetaTagsList data={buildDataForSeoMetaTag(link)} />;
};

export default CanonicalLink;
